module.exports = __webpack_public_path__ + "da7c3ae32d80fd18d0bb8a82c7c61eb7.svg";